(() => {
  if (window.__infoStoreRentalTrackingBooted) return;
  window.__infoStoreRentalTrackingBooted = true;

  const GA4_PATTERN = /^G-[A-Z0-9]+$/;
  const ADS_PATTERN = /^AW-\d+\/[A-Za-z0-9_-]+$/;
  const ALLOWED_POSITIONS = new Set(['hero', 'optiplex', 'latitude', 'sla', 'dimensionador', 'final', 'floating']);
  const tagState = {
    loaderReady: false,
    configuredIds: new Set(),
    analyticsAllowed: false,
    marketingAllowed: false,
  };

  const gtag = (...args) => {
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    window.gtag(...args);
  };

  const readConfig = (root) => ({
    enabled: root.dataset.rentalLeadTrackingEnabled === 'true',
    ga4: GA4_PATTERN.test(root.dataset.ga4MeasurementId || '') ? root.dataset.ga4MeasurementId : '',
    ads: ADS_PATTERN.test(root.dataset.googleAdsRentalPrimary || '')
      ? [root.dataset.googleAdsRentalPrimary]
      : [],
  });

  const ensureGoogleTag = (measurementId) => {
    if (tagState.loaderReady || !measurementId) return;
    tagState.loaderReady = true;

    gtag('consent', 'default', {
      analytics_storage: 'denied',
      ad_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied',
    });

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`;
    document.head.appendChild(script);
    gtag('js', new Date());
  };

  const configureAllowedDestinations = (config) => {
    const adsIds = config.ads.map((value) => value.split('/')[0]);
    const allowedIds = [
      ...(tagState.analyticsAllowed && config.ga4 ? [config.ga4] : []),
      ...(tagState.marketingAllowed ? adsIds : []),
    ];

    if (!allowedIds.length) return;
    ensureGoogleTag(allowedIds[0]);

    [...new Set(allowedIds)].forEach((id) => {
      if (tagState.configuredIds.has(id)) return;
      tagState.configuredIds.add(id);
      gtag('config', id, { send_page_view: false });
    });
  };

  const syncConsent = (config) => {
    const privacy = window.Shopify?.customerPrivacy;
    if (!privacy) return;

    tagState.analyticsAllowed = privacy.analyticsProcessingAllowed();
    tagState.marketingAllowed = privacy.marketingAllowed();
    if (tagState.analyticsAllowed || tagState.marketingAllowed) {
      ensureGoogleTag(config.ga4 || config.ads[0]?.split('/')[0]);
      gtag('consent', 'update', {
        analytics_storage: tagState.analyticsAllowed ? 'granted' : 'denied',
        ad_storage: tagState.marketingAllowed ? 'granted' : 'denied',
        ad_user_data: tagState.marketingAllowed ? 'granted' : 'denied',
        ad_personalization: tagState.marketingAllowed ? 'granted' : 'denied',
      });
      configureAllowedDestinations(config);
    } else if (tagState.loaderReady) {
      gtag('consent', 'update', {
        analytics_storage: 'denied',
        ad_storage: 'denied',
        ad_user_data: 'denied',
        ad_personalization: 'denied',
      });
    }
  };

  const publishLead = (config, position) => {
    if (!ALLOWED_POSITIONS.has(position)) return;

    const payload = {
      lead_type: 'locacao_computadores',
      contact_method: 'whatsapp',
      cta_position: position,
      page_path: window.location.pathname,
    };

    try {
      window.Shopify?.analytics?.publish?.('infostore_rental_lead', payload);
    } catch (_) {}

    try {
      if (tagState.analyticsAllowed && config.ga4) {
        gtag('event', 'generate_lead', { ...payload, send_to: config.ga4 });
      }
      if (tagState.marketingAllowed) {
        config.ads.forEach((destination) => gtag('event', 'conversion', { send_to: destination }));
      }
    } catch (_) {}
  };

  const init = (root) => {
    if (root.dataset.rentalTrackingReady === 'true') return;
    root.dataset.rentalTrackingReady = 'true';

    const config = readConfig(root);
    if (!config.enabled) return;

    if (window.Shopify?.customerPrivacy) syncConsent(config);
    window.Shopify?.loadFeatures?.(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      (error) => { if (!error) syncConsent(config); },
    );
    document.addEventListener('visitorConsentCollected', () => syncConsent(config));

    const quoteForm = root.querySelector('[data-rental-quote-form]');
    quoteForm?.addEventListener('submit', () => {
      if (typeof quoteForm.checkValidity === 'function' && !quoteForm.checkValidity()) return;
      publishLead(config, 'dimensionador');
    });

    root.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      const target = event.target.closest('[data-rental-lead-position]');
      if (!target || !root.contains(target)) return;
      const position = target.dataset.rentalLeadPosition;
      if (position === 'dimensionador') return;
      publishLead(config, position);
    });
  };

  document.querySelectorAll('[data-rental-section]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.matches('[data-rental-section]')
      ? event.target
      : event.target.querySelector('[data-rental-section]');
    if (root) init(root);
  });
})();
